(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[852],{

/***/ 3238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "aG": function() { return /* binding */ Breadcrumb; },
/* harmony export */   "gN": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* unused harmony exports BreadcrumbSeparator, useBreadcrumbStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5235);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4520);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2446);
// ../../react-shim.js


// src/breadcrumb.tsx





// src/breadcrumb-context.ts

var [BreadcrumbStylesProvider, useBreadcrumbStyles] = (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .kr)({
  name: `BreadcrumbStylesContext`,
  errorMessage: `useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Breadcrumb />" `
});

// src/breadcrumb.tsx
var Breadcrumb = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Breadcrumb2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useMultiStyleConfig */ .jC)("Breadcrumb", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const {
    children,
    spacing = "0.5rem",
    separator = "/",
    className,
    ...rest
  } = ownProps;
  const validChildren = (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_1__/* .getValidChildren */ .WR)(children);
  const count = validChildren.length;
  const clones = validChildren.map((child, index) => (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
    separator,
    spacing,
    isLastChild: count === index + 1
  }));
  const _className = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-breadcrumb", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.nav */ .m$.nav, {
    ref,
    "aria-label": "breadcrumb",
    className: _className,
    __css: styles.container,
    ...rest
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.ol */ .m$.ol, {
    className: "chakra-breadcrumb__list"
  }, clones)));
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .__DEV__ */ .Ts) {
  Breadcrumb.displayName = "Breadcrumb";
}

// src/breadcrumb-item.tsx




// src/breadcrumb-separator.tsx


var BreadcrumbSeparator = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbSeparator2(props, ref) {
  const { spacing, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const separatorStyles = {
    mx: spacing,
    ...styles.separator
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
    ref,
    role: "presentation",
    ...rest,
    __css: separatorStyles
  });
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .__DEV__ */ .Ts) {
  BreadcrumbSeparator.displayName = "BreadcrumbSeparator";
}

// src/breadcrumb-link.tsx


var BreadcrumbLink = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbLink2(props, ref) {
  const { isCurrentPage, as, className, href, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const sharedProps = {
    ref,
    as,
    className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-breadcrumb__link", className),
    ...rest
  };
  if (isCurrentPage) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
      "aria-current": "page",
      __css: styles.link,
      ...sharedProps
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.a */ .m$.a, {
    __css: styles.link,
    href,
    ...sharedProps
  });
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .__DEV__ */ .Ts) {
  BreadcrumbLink.displayName = "BreadcrumbLink";
}

// src/breadcrumb-item.tsx

var BreadcrumbItem = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbItem2(props, ref) {
  const {
    isCurrentPage,
    separator,
    isLastChild,
    spacing,
    children,
    className,
    ...rest
  } = props;
  const validChildren = (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_1__/* .getValidChildren */ .WR)(children);
  const clones = validChildren.map((child) => {
    if (child.type === BreadcrumbLink) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        isCurrentPage
      });
    }
    if (child.type === BreadcrumbSeparator) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        spacing,
        children: child.props.children || separator
      });
    }
    return child;
  });
  const styles = useBreadcrumbStyles();
  const itemStyles = {
    display: "inline-flex",
    alignItems: "center",
    ...styles.item
  };
  const _className = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-breadcrumb__list-item", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.li */ .m$.li, {
    ref,
    className: _className,
    ...rest,
    __css: itemStyles
  }, clones, !isLastChild && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbSeparator, {
    spacing
  }, separator));
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .__DEV__ */ .Ts) {
  BreadcrumbItem.displayName = "BreadcrumbItem";
}



/***/ }),

/***/ 5978:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gramas",
      function () {
        return __webpack_require__(6111);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/Button/index.tsx
var Button = __webpack_require__(8859);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/icons/leaf-bg-1.svg
/* harmony default export */ var leaf_bg_1 = ({"src":"/_next/static/media/leaf-bg-1.1045a309.svg","height":35,"width":41});
;// CONCATENATED MODULE: ./public/images/icons/leaf-bg-2.svg
/* harmony default export */ var leaf_bg_2 = ({"src":"/_next/static/media/leaf-bg-2.8cddd2e9.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./components/Card/styles.ts






var Texts = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    paddingInline: 25,
    "&::before": {
        content: "url(".concat(leaf_bg_1.src, ")"),
        visibility: "hidden",
        opacity: 0,
        position: "absolute",
        left: 20,
        top: 0,
        transition: "all 0.3s"
    },
    "&::after": {
        content: "url(".concat(leaf_bg_2.src, ")"),
        visibility: "hidden",
        opacity: 0,
        position: "absolute",
        right: 30,
        bottom: 10,
        transition: "all 0.3s"
    }
});
var Card = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    textAlign: "center",
    borderRadius: 8,
    overflow: "hidden",
    border: "solid 1px",
    borderColor: "transparent",
    transition: "all 0.3s",
    "&:hover": (0,_define_property/* default */.Z)({
        border: "solid 1px",
        borderColor: "$emerald500",
        cursor: "pointer",
        transition: "all 0.3s"
    }, "& ".concat(Texts), {
        "&::before, &::after": {
            opacity: 1,
            visibility: "visible",
            transition: "all 0.3s"
        }
    })
});
var ImageWrap = (0,stitches_config/* styled */.zo)("figure", {
    position: "relative",
    width: "100%",
    height: 230,
    marginBottom: 14
});
var Image = (0,stitches_config/* styled */.zo)((image_default()), {});
var Title = (0,stitches_config/* styled */.zo)("h3", {
    marginBottom: 14,
    fontSize: "20px !important",
    color: "$grey900",
    lineHeight: "120%",
    fontFamily: "$domine",
    fontWeight: "bold",
    textTransform: "capitalize"
});
var Description = (0,stitches_config/* styled */.zo)("p", {
    marginBottom: 14,
    color: "$grey500",
    fontSize: (0,polished_esm/* rem */.hO)(15),
    fontFamily: "$raleway",
    lineHeight: "180%",
    overflow: "hidden",
    "text-overflow": "ellipsis",
    display: "-webkit-box",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": "2"
});

;// CONCATENATED MODULE: ./components/Card/index.tsx






var shimmer = function(w, h) {
    return '\n<svg width="'.concat(w, '" height="').concat(h, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n  <defs>\n    <linearGradient id="g">\n      <stop stop-color="#333" offset="20%" />\n      <stop stop-color="#222" offset="50%" />\n      <stop stop-color="#333" offset="70%" />\n    </linearGradient>\n  </defs>\n  <rect width="').concat(w, '" height="').concat(h, '" fill="#333" />\n  <rect id="r" width="').concat(w, '" height="').concat(h, '" fill="url(#g)" />\n  <animate xlink:href="#r" attributeName="x" from="-').concat(w, '" to="').concat(w, '" dur="1s" repeatCount="indefinite"  />\n</svg>');
};
var toBase64 = function(str) {
    return  false ? 0 : window.btoa(str);
};
var Card_Card = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onClick: props.onPress,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                    src: props.image,
                    title: props.metaImgTitle,
                    alt: props.metaImgTitle,
                    // placeholder="blur"
                    layout: "fill",
                    objectFit: "cover",
                    blurDataURL: "data:image/svg+xml;base64,".concat(toBase64(shimmer("100%", "100%")))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Texts, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        title: props.metaTitle,
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: props === null || props === void 0 ? void 0 : (ref = props.description) === null || ref === void 0 ? void 0 : ref.replace(/<[^>]*>?/gm, "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "transparent",
                        onClick: props.onPress,
                        children: "Ver detalhes"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_Card = (Card_Card);


/***/ }),

/***/ 7309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/index.esm.js
var index_esm = __webpack_require__(3238);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Footer/index.tsx + 2 modules
var Footer = __webpack_require__(7386);
// EXTERNAL MODULE: ./components/Navbar/index.js + 4 modules
var Navbar = __webpack_require__(6697);
// EXTERNAL MODULE: ./components/Container/index.tsx
var Container = __webpack_require__(1344);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
;// CONCATENATED MODULE: ./components/Layout/Default/styles.ts


var Top = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    "& .chakra-breadcrumb": {
        fontFamily: "$raleway",
        fontWeight: 600,
        fontSize: (0,polished_esm/* rem */.hO)(12),
        color: "$grey600",
        "& li": {
            "&:last-of-type": {
                color: "$emerald500"
            }
        }
    }
});
var Background = (0,stitches_config/* styled */.zo)("div", {
    width: "100%",
    paddingTop: 60,
    backgroundImage: "url(/banner_gramas.webp)",
    backgroundSize: "cover",
    position: "relative"
});
var WrapBox = (0,stitches_config/* styled */.zo)("div", {});
var Box = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    left: "50%",
    marginTop: 90,
    padding: "16px",
    transform: "translateX(-50%)",
    flexDirection: "column",
    background: "$white",
    borderRadius: "32px 32px 0 0",
    textAlign: "center",
    width: "90%",
    "@xl": {
        padding: "16px 90px",
        width: "auto",
        display: "inline-flex"
    }
});
var Category = (0,stitches_config/* styled */.zo)("h1", {
    fontFamily: "$domine",
    fontWeight: "bold",
    color: "$grey900",
    fontSize: (0,polished_esm/* rem */.hO)(24),
    "@md": {
        fontSize: (0,polished_esm/* rem */.hO)(54)
    }
});
var CategorySmall = (0,stitches_config/* styled */.zo)("h2", {
    fontFamily: "$raleway",
    fontWeight: " !important",
    color: "$grey900",
    margin: "16px 0",
    fontSize: "".concat((0,polished_esm/* rem */.hO)(16), " !important")
});
var ScientifcName = (0,stitches_config/* styled */.zo)("h2", {
    fontFamily: "$raleway",
    fontWeight: "normal !important",
    fontStyle: "italic",
    color: "$grey900",
    margin: "16px 0",
    fontSize: "".concat((0,polished_esm/* rem */.hO)(16), " !important")
});
var Main = (0,stitches_config/* styled */.zo)("main", {
    "& section": {
        paddingTop: 50,
        paddingBottom: 100
    }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var dist_index_esm = __webpack_require__(3382);
;// CONCATENATED MODULE: ./components/Layout/Default/index.tsx













var convertBreadcrumb = function(string) {
    return string.replace(/-/g, " ").replace(/oe/g, "\xf6").replace(/ae/g, "\xe4").replace(/ue/g, "\xfc").charAt(0).toUpperCase() + string.slice(1);
};
function Layout(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), breadcrumbs = ref[0], setBreadcrumbs = ref[1];
    (0,react.useEffect)(function() {
        if (router) {
            var linkPath = router.asPath.split("/");
            linkPath.shift();
            var pathArray = linkPath.map(function(path, i) {
                return {
                    breadcrumb: path.split("?")[0],
                    href: "/" + linkPath.slice(0, i + 1).join("/")
                };
            });
            setBreadcrumbs(pathArray);
        }
    }, [
        router
    ]);
    // if (!breadcrumbs) {
    //   return null
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: props.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: props.keywords
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    props.links && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://centraldagrama.com".concat(props.links)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: props.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(props.cover ? props.cover : "https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:card",
                        content: "summary_large_image"
                    }),
                    props.links && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://centraldagrama.com/".concat(props.links)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:title",
                        content: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:description",
                        content: props.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:image",
                        content: "".concat(props.cover ? props.cover : "https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Top, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Background, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapBox, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                                        css: props.categorySize ? (0,_object_spread/* default */.Z)({}, {
                                            fontSize: "".concat(props.categorySize, " !important")
                                        }) : {},
                                        children: props.category
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Breadcrumb */.aG, {
                                        separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ChevronRightIcon */.XC, {
                                            color: "gray.600"
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbItem */.gN, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbLink */.At, {
                                                        children: "In\xedcio"
                                                    })
                                                })
                                            }),
                                            breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map(function(breadcrumb, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbItem */.gN, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: breadcrumb.href,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbLink */.At, {
                                                            children: convertBreadcrumb(breadcrumb.breadcrumb)
                                                        })
                                                    })
                                                }, i);
                                            })
                                        ]
                                    }),
                                    props.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScientifcName, {
                                        children: props.subtitle
                                    }),
                                    props.h2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySmall, {
                                        children: props.h2
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};


/***/ }),

/***/ 6111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8641);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Layout_Default__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7309);
/* harmony import */ var components_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1344);
/* harmony import */ var components_Card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4143);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5313);








var getSplittedName = function(value) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(value.toLowerCase().split("GRAMA "), 1), name = ref[0];
    return name;
};
var Dicas = function(param) {
    var data = param.data;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Layout_Default__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        category: "Gramas",
        title: "Tipos de gramas para comprar",
        description: "Selecione o tipo de grama que est\xe1 procurando, saiba mais sobre cada variedade, fa\xe7a a melhor escolha de acordo com sua necessidade e estamos a disposi\xe7\xe3o...",
        keywords: "gramas, tipos de grama, qual melhor tipo de grama, grama para jardim, grama para beira de piscina, grama para talude, grama para sombra, grama para campo de futebol, grama para ch\xe1cara",
        categorySize: "1.6rem",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .SimpleGrid */ .MI, {
                    columns: [
                        1,
                        1,
                        2,
                        null,
                        3
                    ],
                    spacing: 15,
                    children: data === null || data === void 0 ? void 0 : data.map(function(item) {
                        var ref, ref1, ref2;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Card__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            image: (0,utils__WEBPACK_IMPORTED_MODULE_7__/* .transformHttpToHttps */ .T)(item.x_featured_media_original),
                            title: getSplittedName(item.title.rendered),
                            description: "".concat(item.excerpt.rendered, " ..."),
                            onPress: function() {
                                return router.push(item.slug);
                            },
                            metaImgTitle: item === null || item === void 0 ? void 0 : (ref = item.acf) === null || ref === void 0 ? void 0 : ref.title_img_othergrass,
                            metaImgAlt: item === null || item === void 0 ? void 0 : (ref1 = item.acf) === null || ref1 === void 0 ? void 0 : ref1.alt_img_othergrass,
                            metaTitle: item === null || item === void 0 ? void 0 : (ref2 = item.acf) === null || ref2 === void 0 ? void 0 : ref2.title_text_othergrass
                        }, "grass-".concat(item.id));
                    })
                })
            })
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Dicas);


/***/ }),

/***/ 5313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ countComments; },
/* harmony export */   "T": function() { return /* binding */ transformHttpToHttps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9815);



var countComments = function(comments) {
    var flatComments = comments.flatMap(function(comment) {
        if (comment.replies) {
            return [
                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, comment), {
                    replies: false
                })
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(comment.replies.map(function(reply) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, reply), {
                    status: false
                });
            })));
        }
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, comment), {
            replies: false
        });
    });
    var commentsActive = flatComments.filter(function(item) {
        return item.status;
    });
    return (commentsActive === null || commentsActive === void 0 ? void 0 : commentsActive.length) || 0;
};
var transformHttpToHttps = function(url) {
    if (!url) return "";
    return url.replace("http://", "https://");
};


/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [753,112,774,888,179], function() { return __webpack_exec__(5978); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);